import {PROJECT_BASE_PATH} from '../workspace/multiRunWorkspacePaths';

export const NOTEBOOKS_PATH = '/notebooks';
export const NOTEBOOKS_YOUR_NOTEBOOKS_PATH = '/notebooks/your-notebooks';
export const NOTEBOOKS_HOME_PATHS = [
  NOTEBOOKS_PATH,
  NOTEBOOKS_YOUR_NOTEBOOKS_PATH,
];

export const PROJECT_NOTEBOOKS_PATH = `${PROJECT_BASE_PATH}/:tab(notebooks)`;
export const MARIMO_NOTEBOOK_EDIT_PATH = `${PROJECT_NOTEBOOKS_PATH}/:notebookId/edit`;

export function projectNotebooksPath({
  entityName,
  projectName,
}: {
  entityName: string;
  projectName: string;
}): string {
  return `/${entityName}/${projectName}/notebooks`;
}

export function marimoNotebookEditPath({
  notebookId,
  entityName,
  projectName,
}: {
  notebookId: string;
  entityName: string;
  projectName: string;
}): string {
  return `/${entityName}/${projectName}/notebooks/${encodeURIComponent(
    notebookId
  )}/edit`;
}
